<template>
  <div id="contentMrg">
    <TopList :navList="navList" @setType="setType"></TopList>
    <All v-if="type === 0"></All>
    <Paper v-else :index="name"></Paper>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import All from "./components/all";
import Paper from "./components/paper";
import { mapState } from "vuex";

export default {
  name: "index",
  components: {
    TopList,
    All,
    Paper,
  },
  data() {
    return {
      type: 0,
      name: "",
      navList: ["全部", "期刊论文","专著"],
    };
  },
  created() {
    let isSon = sessionStorage.getItem("isSon");
    if (isSon === "true") {
      const arr = JSON.parse(sessionStorage.getItem("userInfo")).permissionUrls[9] ? JSON.parse(sessionStorage.getItem("userInfo")).permissionUrls[9] : []
      this.navList = arr.map(item => {
        if (item.name === '论文') {
          return '期刊论文'
        }
        if (item.name === '报告') {
          return '行业报告'
        }
        return item.name
      })
      this.navList = this.navList.filter(item => item !== '资讯' && item !== '征稿函' && item !== '会议' && item !== '课程')
      this.navList.unshift('全部')
      return
    }
    if (this.userInfo.user.customerType === 4) {
      this.navList = ["全部", "期刊论文"];
    } else if (this.userInfo.user.customerType === 5) {
      this.navList = ["全部", "期刊论文","专著"];
    }
  },
  mounted(){},
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    setType(e) {
      this.type = e;
      this.name = this.navList[e];
    },
  },
};
</script>

<style lang="scss" scoped>
#contentMrg {
  width: 1200px;
}
</style>
